/**
 * RegionCalendarLink — a button back to the calendar of the region the
 * workshop belongs to. Renders nothing when the workshop has no region.
 */
import { ChevronLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

import type { WorkshopDetail } from '../../../../api/workshops';

import { useRegionCalendarHref } from './use-region-calendar-href';
import { useWorkshopViewMode } from './workshopDetailContext';

export function RegionCalendarLink({ workshop }: { workshop: WorkshopDetail }) {
  const href = useRegionCalendarHref(useWorkshopViewMode(), workshop);
  if (!href) return null;

  return (
    <Link
      to={href}
      className="nb-btn nb-btn-ghost"
      style={{
        alignSelf: 'flex-start',
        fontSize: 12,
        textDecoration: 'none',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
      }}
    >
      <ChevronLeft size={14} aria-hidden="true" />
      Back to {workshop.venueRegionName} calendar
    </Link>
  );
}
